import { serverURL } from "@/utils/serverURL";
import type { FixedIngredientRef } from "@/utils/types/flavor";

export async function searchFixedIngredients(
  q: string,
): Promise<FixedIngredientRef[]> {
  const res = await fetch(
    serverURL`/me/search/fixed-ingredients?q=${encodeURIComponent(q)}`,
    { credentials: "include" },
  );
  if (!res.ok) {
    throw new Error(`search/fixed-ingredients failed: ${res.status}`);
  }
  return (await res.json()) as FixedIngredientRef[];
}
